import { FlagsComponentRouter, FlagsSingleton } from 'flags'
import { isMiddleSchoolUrl, isK5Url } from 'utils/routing/routeHelpers'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-20164-k5-site-selection'],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) => {
    const isMiddleSchool = isMiddleSchoolUrl()

    const isK5 =
      isK5Url() && subscribedFlags['feature_LEARN-20164-k5-site-selection']

    return isMiddleSchool || isK5
  },
})

export default FlagToggler
